import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import { Flex, Heading, Divider } from "@chakra-ui/react";
import DiaryList from "./components/DiaryList";
import DiaryBanner from "./components/DiaryBanner";
import DiaryContinueBanner from "./components/DiaryContinueBanner";
import { getCurrentDate } from "utils/dynDateUtils";

function StudentDiaryPage() {
  const user = useSelector((state) => state.user?.info);
  const navigate = useNavigate();
  const [diaries, setDiaries] = useState([]);
  const [currentDiary, setCurrentDiary] = useState({});

  const fetchAllUserDiaries = async () => {
    try {
      const day = getCurrentDate();
      const { data } = await api.get(
        `${API_BASE}/api/student-diary/diaries?day=${day}&page=0&size=30`
      );
      console.log("user diaries: ", data);
      setDiaries(data?.oldDiaries);
      setCurrentDiary(data?.currentDiary);
    } catch (error) {
      console.error("Failed to fetch user diaries:", error);
    }
  };

  useEffect(() => {
    fetchAllUserDiaries();
  }, [user]);

  return (
    <Flex flexDirection="column">
      <Heading size="lg">Mood & Moments</Heading>
      <Divider mt={4} mb={4} />
      <Heading size="md" mb={4} color="teal.700">
        What's Up Today?
      </Heading>
      {currentDiary ? (
        <DiaryContinueBanner diary={currentDiary} />
      ) : (
        <DiaryBanner />
      )}

      {diaries && (
        <>
          <Divider mt={4} mb={4} />
          <Heading size="md" mb={4} color="teal.700">
            My Stories So Far...
          </Heading>
          <DiaryList diaries={diaries} />
        </>
      )}
    </Flex>
  );
}

export default StudentDiaryPage;
